import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import withReactiveStyleBuyButton from '../withReactiveStyleBuyButton';
import { approveResellerOrder } from '../../Actions/Order.action';

const ApproveOrderButton = ({
  label,
  title,
  cssClass,
  orderId,
  onClick,
  callback,
}) => {
  return (
    <button
      onClick={() => onClick({ orderId, callback })}
      className={cssClass}
      title={title || label}
      type="button"
    >
      {label}
    </button>
  );
};

const StyledButton = (props) => {
  const dispatch = useDispatch();
  const onClick = ({ orderId, callback }) => {
    try {
      dispatch(approveResellerOrder(orderId, callback));
      return true;
    } catch (ex) {
      return false;
    }
  };
  const Button = withReactiveStyleBuyButton(
    ApproveOrderButton,
    onClick,
    'buy-button'
  );
  return <Button {...props} />;
};

export default StyledButton;
